import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "permissions" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_6 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_permissions_actions = _resolveComponent("permissions-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_permissions_list_item = _resolveComponent("permissions-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_permissions_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createPermission,
          onUpdate: _ctx.updatePermission
        }, null, 8, ["loading", "is-create", "is-update", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Доступы" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить доступ ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.loadPermissions(1)), ["prevent"])),
        class: "mt-6 bg-white border px-6 py-4"
      }, [
        _createVNode(_component_the_input, {
          class: "w-full",
          placeholder: "Имя доступа",
          value: _ctx.filters_state.name,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.name) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          placeholder: "ID сервиса",
          loading: _ctx.data_state.microservices.is_loading,
          failed: _ctx.data_state.microservices.is_failed,
          "error-text": "При получении списка компаний произошла ошибка",
          options: _ctx.data_state.microservices.list,
          value: _ctx.filters_state.serviceId,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.serviceId) = $event)),
          "infinite-scroll": "",
          onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMicroservices(_ctx.data_state.microservices.pagination.current_page))),
          onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (
                    _ctx.loadMoreMicroservices(_ctx.data_state.microservices.pagination.current_page + 1)
                )),
          onSearch: _ctx.searchMicroservices,
          onOptionBySearch: _ctx.unshiftFounddMicroservices,
          class: "w-full mt-2"
        }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "second text small mr-2",
            loading: _ctx.data_state.permissions.is_loading,
            onClick: _ctx.resetFilters
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Сброс ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small",
            loading: _ctx.data_state.permissions.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_6, [
        (
                    _ctx.data_state.permissions.is_failed &&
                    !_ctx.data_state.permissions.failure.error_state.is_cancel
                )
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.data_state.permissions.is_loading,
              text: "При получении списка доступов произошла ошибка",
              "error-message": _ctx.data_state.permissions.failure.error_state.message,
              "error-url": _ctx.data_state.permissions.failure.error_state.url,
              "error-status": _ctx.data_state.permissions.failure.error_state.status,
              onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadPermissions(_ctx.data_state.permissions.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_list, {
              key: 1,
              loading: _ctx.data_state.permissions.is_loading,
              items: _ctx.data_state.permissions.list,
              pagination: "",
              "pagination-current-page": _ctx.data_state.permissions.pagination.current_page,
              "pagination-total-pages": _ctx.data_state.permissions.pagination.total_pages,
              onChangePage: _ctx.loadPermissions
            }, {
              item: _withCtx(({ item }) => [
                _createVNode(_component_permissions_list_item, {
                  item: item,
                  loading: _ctx.actions_state.is_actions_loading,
                  onUpdate: _ctx.updatePermission,
                  onDelete: _ctx.deletePermission
                }, null, 8, ["item", "loading", "onUpdate", "onDelete"])
              ]),
              _: 1
            }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
      ])
    ])
  ], 64))
}